import { makeStyles } from "@material-ui/core/styles";

const accordionIcon = `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23333537'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e")`;

export const useStyles = makeStyles(() => ({
  accordionItem: {
    border: "none",
    borderRadius: "7px",
    margin: "0 0 1.5rem 0"
  },
  header: {
    backgroundColor: "#F6F6F6 !important",
    color: "#333537 !important",
    padding: "0 1rem 0 0 !important",
    display: "flex",
    alignItems: "center",
    gap: "1.5rem",
    boxShadow: "none !important",
  },
  titleContainer: {
    flex: 1,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingRight: "1rem",
  },
  title: {
    fontFamily: "'Open Sans', sans-serif",
    fontWeight: 700,
    fontSize: "13px",
  },
  iconContainer: {
    backgroundColor: "#CDD0DE",
    padding: "1rem",
    alignSelf: "stretch",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  icon: {
    fontSize: "1.2rem",
    color: "#333537",
  },
  body: {
    padding: "1rem",
    backgroundColor: "#FFFFFF",
  },
  accordion: {
    "--bs-accordion-btn-icon": accordionIcon,
    "--bs-accordion-btn-active-icon": accordionIcon,
    "--bs-accordion-border-width": "0",
  },
}));
